<template>
  <CoachShell>
    <div class="bg-gradient-to-r from-purple-300 to-blue-200">
      <div class="w-9/12 m-auto py-16 min-h-screen flex items-center justify-center">
        <div class="bg-white shadow overflow-hidden sm:rounded-lg pb-8">
          <div class="border-t border-gray-200 pt-8">

              <div v-if="isCoach" class="p-8 text-center">
              <p>You are already registered as a Coach.</p>
              <base-button
                  link
                  to="/requests"
                  :mode="'px-3 py-1 text-xs leading-5 font-semibold rounded bg-yellow-500 text-white mr-1'"
              >Check your Inbox
              </base-button>

            </div>
              <form
                v-else
                @submit.prevent="submitForm" class="space-y-8 px-16">
              <div class="space-y-8 divide-y divide-gray-200">
                <div class="pt-8">
                  <div>
                    <h1 class="text-2xl leading-6 font-medium text-gray-900">
                      Register as a Coach
                    </h1>
                    <p class="mt-1 text-sm text-gray-500">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium deserunt ea, expedita harum iure porro quas sequi sunt.
                    </p>
                  </div>
                  <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    <div class="sm:col-span-2" :class="{ 'bg-red-200 p-2': !firstName.isValid }">
                      <label for="first_name" class="block text-sm font-medium text-gray-700">
                        First name
                      </label>
                      <div class="mt-1">
                        <input type="text" name="first_name" id="first_name"
                               v-model.trim="firstName.val"
                               @blur="clearValidity('firstName')"
                               autocomplete="given-name" class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full
                sm:text-sm border-gray-300 rounded-md" />
                        <p v-if="!firstName.isValid" class="italic text-xs mt-1">First name is required</p>
                      </div>
                    </div>

                    <div class="sm:col-span-2" :class="{ 'bg-red-200 p-2': !lastName.isValid }">
                      <label for="last_name" class="block text-sm font-medium text-gray-700">
                        Last name
                      </label>
                      <div class="mt-1">
                        <input type="text" name="last_name" id="last_name"
                               v-model.trim="lastName.val"
                               @blur="clearValidity('lastName')"
                               autocomplete="family-name" class="shadow-sm focus:ring-blue-500 focus:border-blue-500
                block w-full sm:text-sm border-gray-300 rounded-md" />
                        <p v-if="!lastName.isValid" class="italic text-xs mt-1">Last name is required</p>
                      </div>
                    </div>


                    <div class="sm:col-span-6" :class="{ 'bg-red-200 p-2': !description.isValid }">
                      <label for="about" class="block text-sm font-medium text-gray-700">
                        About
                      </label>
                      <div class="mt-1">
                <textarea
                    id="about"
                    name="about"
                    v-model.trim="description.val"
                    @blur="clearValidity('description')"
                    rows="5"
                    class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                      </div>
                      <p class="mt-2 text-sm text-gray-500">Write a few sentences about yourself.</p>
                      <p v-if="!description.isValid" class="italic text-xs mt-1">Description is required</p>
                    </div>

                    <div class="sm:col-span-2" :class="{ 'bg-red-200 p-2': !rate.isValid }">
                      <label for="" class="block text-sm font-medium text-gray-700">
                        Hourly rate ($)
                      </label>
                      <div class="mt-1">
                        <input type="number"
                               v-model.number="rate.val"
                               @blur="clearValidity('rate')"
                               id="rate"
                               class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                        <p v-if="!rate.isValid" class="italic text-xs mt-1">Rate is required</p>
                      </div>
                    </div>

                    <div class="sm:col-span-2" :class="{ 'bg-red-200 p-2': !areas.isValid }">
                      <label for="" class="block text-sm font-medium text-gray-700">
                        Areas of Expertise
                      </label>
                      <div class="mt-1">
                        <fieldset>
                          <div class="space-y-2">
                            <div class="relative flex items-start">
                              <div class="flex items-center h-5">
                                <input id="frontend" value="frontend"
                                       v-model="areas.val"
                                       @blur="clearValidity('areas')"
                                       type="checkbox"
                                       class="focus:ring-blue-500 h-4 w-4 text-purple-500 border-gray-300 rounded" />
                              </div>
                              <div class="ml-3 text-sm">
                                <label for="" class="font-medium text-gray-700">Frontend</label>
                              </div>
                            </div>
                            <div class="relative flex items-start">
                              <div class="flex items-center h-5">
                                <input id="backend" value="backend"
                                       v-model="areas.val"
                                       @blur="clearValidity('areas')"
                                       type="checkbox" class="focus:ring-blue-500 h-4 w-4 text-purple-500 border-gray-300 rounded" />
                              </div>
                              <div class="ml-3 text-sm">
                                <label for="" class="font-medium text-gray-700">Backend</label>
                              </div>
                            </div>
                            <div class="relative flex items-start">
                              <div class="flex items-center h-5">
                                <input id="career" value="career"
                                       v-model="areas.val"
                                       @blur="clearValidity('areas')"
                                       type="checkbox" class="focus:ring-blue-500 h-4 w-4 text-purple-500 border-gray-300 rounded" />
                              </div>
                              <div class="ml-3 text-sm">
                                <label for="" class="font-medium text-gray-700">Career</label>
                              </div>
                            </div>
                            <p v-if="!areas.isValid" class="italic text-xs mt-1">Please select at leat one area of expertise. </p>
                          </div>
                        </fieldset>
                      </div>
                    </div>

                    <div class="sm:col-span-6">
                      <label for="last_name" class="block text-sm font-medium text-gray-700">
                        Profile pic (optional)<br>
                        <span class="text-xs">Since this is only a <strong>demo app</strong>, uploads are forbidden. You can select a link to the image from:
                  <a href="https://randomuser.me/photos" target="_blank" class="text-purple-500">Random User Generator</a>.
                  <br>If no pic is selected, a generic one will be applied for the coach profile.</span>
                      </label>
                      <div class="mt-1">
                        <input type="text" name="pic" id="pic" v-model.trim="pic" autocomplete="family-name" class="shadow-sm focus:ring-blue-500 focus:border-blue-500
                block w-full sm:text-sm border-gray-300 rounded-md" />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="pt-5">
                <div v-if="!formIsValid" class="rounded bg-red-200 p-3 mb-3">
                  <p>Please fix the above errors. </p>
                </div>
                <div class="flex justify-center">
                  <!--          <button type="button"-->
                  <!--                  class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50-->
                  <!--                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">-->
                  <!--            Clear-->
                  <!--          </button>-->
                  <button type="submit"
                          class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-purple-500 hover:bg-purple-700
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500">
                    Register
                  </button>
                </div>
              </div>
              <div v-if="error" class="bg-red-400 p-2 rounded-sm">{{ error }}</div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </CoachShell>
</template>

<script>
import CoachShell from "./CoachShell";
export default {
  name: "CoachRegistration",
  components: {
    CoachShell,
  },
  data(){
    return{
      firstName: {
        val: '',
        isValid: true,
      },
      lastName: {
        val: '',
        isValid: true,
      },
      description: {
        val: '',
        isValid: true,
      },
      rate: {
        val: null,
        isValid: true,
      },
      areas: {
        val: [],
        isValid: true,
      },
      pic: '', //todo optional
      formIsValid: true,
      error: null,
    };
  },
  computed: {
    isCoach(){
      return this.$store.getters['coaches/isCoach'];
    },
    // isLoggedIn(){
    //   return this.$store.getters.isAuthenticated;
    // }
  },
  methods: {
    async submitForm(){
      //todo validate form
      this.error = null;
      this.validateForm();

      if (!this.formIsValid) {
        return;
      }

      const formData = {
        first: this.firstName.val,
        last: this.lastName.val,
        rate: this.rate.val,
        desc: this.description.val,
        areas: this.areas.val,
        pic: this.pic,
      }

      //todo call vuex
      try {
        await this.$store.dispatch('coaches/registerCoach', formData);
      }
      catch(error){
        this.error = error.message || 'Failed to register a coach';
      }

    },
    validateForm(){
      this.formIsValid = true;
      if (this.firstName.val === '') {
        this.firstName.isValid = false;
        this.formIsValid = false;
      }
      if (this.lastName.val === '') {
        this.lastName.isValid = false;
        this.formIsValid = false;
      }
      if (this.description.val === '') {
        this.description.isValid = false;
        this.formIsValid = false;
      }
      if (!this.rate.val || this.rate.val < 0) {
        this.rate.isValid = false;
        this.formIsValid = false;
      }
      if (this.areas.val.length === 0) {
        this.areas.isValid = false;
        this.formIsValid = false;
      }
    },
    clearValidity(input) {
      this[input].isValid = true;
    },
  },
}
</script>